import React from "react";

export function ScanProgress({ status, progress, total, niche, area }) {
  const pct =
    total > 0 ? Math.round((Math.min(progress, total) / total) * 100) : 0;
  const label = {
    pending: "Warming up…",
    discovering: "Discovering businesses…",
    fetching: `Fetching posts · ${progress}/${total}`,
    completed: `Scan complete · ${total} businesses`,
    failed: "Scan failed",
  }[status || "pending"] || "Working…";

  const isActive =
    status === "pending" || status === "discovering" || status === "fetching";

  return (
    <div
      data-testid="scan-progress"
      className="flex flex-col gap-2 rounded-lg border border-border bg-white p-4"
    >
      <div className="flex items-center justify-between gap-4">
        <div className="min-w-0">
          <div className="truncate font-sans text-sm font-semibold text-ink">
            {niche || "—"}{" "}
            <span className="text-muted-foreground">· {area || "—"}</span>
          </div>
          <div className="mt-0.5 font-mono text-[11px] uppercase tracking-wider text-muted-foreground">
            {label}
          </div>
        </div>
        <div className="font-mono text-sm tabular-nums text-ink">
          {status === "completed" ? "100%" : `${pct}%`}
        </div>
      </div>
      <div className="relative h-1.5 w-full overflow-hidden rounded-full bg-black/5">
        <div
          className={`absolute inset-y-0 left-0 bg-electric transition-[width] duration-500 ${
            isActive && pct === 0 ? "gbp-shimmer" : ""
          }`}
          style={{ width: `${status === "completed" ? 100 : Math.max(pct, isActive ? 6 : 0)}%` }}
        />
      </div>
    </div>
  );
}
